export const orderAttributes = {
  description: { id: 'description', label: 'Descripción', i18nId: 'workOrders.attributes.description' },
  assignee: { id: 'assignee', label: 'Asignado a', i18nId: 'workOrders.attributes.assignee' },
  priority: { id: 'priority', label: 'Prioridad', i18nId: 'workOrders.attributes.priority' },
  status: { id: 'status', label: 'Estado', i18nId: 'common.status' },
  expected_completion_date: {
    id: 'expected_completion_date',
    label: 'Fecha estimada de completitud',
    i18nId: 'workOrders.attributes.expected_completion_date'
  },
  inspectionType: { id: 'inspectionType', label: 'Tipo de inspección', i18nId: 'workOrders.attributes.inspectionType' },
  formulary: { id: 'formulary', label: 'Formulario', i18nId: 'workOrders.attributes.formulary' }
};

export const orderStatuses = [
  { id: 'todo', label: 'Pendiente', i18nId: 'workOrders.orderStatuses.pending' },
  { id: 'in_progress', label: 'En progreso', i18nId: 'workOrders.orderStatuses.inProgress' },
  { id: 'done', label: 'Completada', i18nId: 'workOrders.orderStatuses.done' },
  { id: 'cancelled', label: 'Cancelada', i18nId: 'workOrders.orderStatuses.cancelled' }
];

export const orderPriorities = [
  { id: 1, label: 'Muy Alta', i18nId: 'workOrders.priority.highest' },
  { id: 2, label: 'Alta', i18nId: 'workOrders.priority.high' },
  { id: 3, label: 'Media', i18nId: 'workOrders.priority.medium' },
  { id: 4, label: 'Baja', i18nId: 'workOrders.priority.low' },
  { id: 5, label: 'Muy Baja', i18nId: 'workOrders.priority.lowest' }
];

export const inspectionTypes = [
  { type: 'route', name: 'Por recorrido', i18nId: 'workOrders.inspectionType.byTracking' },
  { type: 'formulary', name: 'Por formularios', i18nId: 'workOrders.inspectionType.byForm' }
];
